<ui-table
  *ngIf="users && users.length"
  [data]="users"
  [isWrapped]="false"
  [tblColor]="true"
  [tblRoundBottom]="true"
  (requestUpdate)="outputPaginationData($event)"
  [totalRecords]="totalRecords"
  [numberOfRows]="numberOfRows"
  [displayFilter]="[
    'userId',
    'username',
    'userDescr',
    'roleDescr',
    'clinicDescr',
    'phone'
  ]"
  [templates]="[
    {
      title: 'translate.general.activeSw',
      colClass: 'l-ta-center ui-p-5',
      template: activeSw,
      permission: true
    },
    {
      colClass: 'cell-50',
      template: editUserBtn,
      permission: true
    }
  ]"
  [colSet]="[
    {
      key: 'userDescr',
      colClass: 'ui-p-3'
    },
    {
      key: 'roleDescr',
      colClass: 'ui-p-5'
    },
    {
      key: 'clinicDescr',
      colClass: 'ui-p-6'
    },
    {
      key: 'phone',
      colClass: 'ui-p-6'
    }
  ]"
></ui-table>

<ng-template #editUserBtn let-row="row">
  <button
    class="btn-editUser"
    [tooltip]="'translate.users.editUser' | translate"
    (click)="editUser(row)"
  ></button>
</ng-template>

<ng-template #activeSw let-row="row">
  <i
    class="fas"
    [class.fa-check]="row.cognitoStatusSw"
    [class.c-success]="row.cognitoStatusSw"
    [class.fa-times]="!row.cognitoStatusSw"
    [class.c-warn]="!row.cognitoStatusSw"
  ></i>
</ng-template>
